export default (round) => {
    if (!round) return [];

    const { taskTypes } = round;

    if (!taskTypes) return [];

    return taskTypes.map(({ id }) => id);
};
